export const REAUTHENTICATION_COMPLETE_PATH = '/oauth2/reauthenticated';
